import React from 'react'

import singletons from '../singletons'

export class LoadingComponent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false
    }

    singletons['loading'] = this
  }

  start() {
    this.setState({
      loading: true
    })
  }

  stop() {
    this.setState({
      loading: false
    })
  }

  render() {
    if(!this.state.loading)
      return null
    return (
      <div className="loading">
        <div className="loading__spinner"></div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/shared/loading/loading.component.jsx